import { Component, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import { IGrupoDTO } from 'src/app/core/dto/grupo.dto';
import { IJwtCredencialesDTO } from 'src/app/core/dto/jwt-credenciales.dto';
import { CertificacionesService} from 'src/app/core/servicios/certificaciones.service';
import { SeguridadService } from 'src/app/core/servicios/seguridad.service';
import { UtilidadService } from 'src/app/core/servicios/utilidad.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css']
})
export class LayoutComponent implements OnInit {

  public credenciales: IJwtCredencialesDTO | null = null;
  public perfil: IGrupoDTO | null = null;

  public avatar: string = ''

  constructor(
    private seguridadService: SeguridadService, 
    private router: Router, 
    private certificacionesService: CertificacionesService,
    private utilidadService: UtilidadService
    ) { }

  ngOnInit(): void {
    this.seguridadService.obtenerOAutenticar();
    this.seguridadService.obtenerOEstablecerPerfilEnSesion();
    this.getAutenticacion();
    this.getPerfilSesion();
    this.getFoto();
  }

  //Eventos

  onClickLogout(): void {
    this.seguridadService.logout();
    this.router.navigate(['/login']);
  }

  onClickNavigate(ruta: string): void {
    this.router.navigate([ruta]);
  }

  // Fetch

  private  getAutenticacion():void{
    this.seguridadService.getAutenticacion().subscribe(
      (res) => {
        //console.log(res);
        this.credenciales = res;
      },
      (err) =>{
        //console.error(err);
      }
    );
  }

  private getPerfilSesion():void{
    this.seguridadService.getPerfilEnSesion().subscribe(
      (res) => {
        //console.log(res);
        this.perfil = res;
      },
      (err) =>{
        //console.error(err);
      }
    );
  }

  private getFoto():void{
    this.certificacionesService.getFoto().subscribe(
      (res) => {
        //console.log(res)
        this.utilidadService.toBase64(res, (base64:string)=>{
          this.avatar = base64
        });
      },
      (err) =>{
        //console.error(err);
      }
    );
  }

}
